"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelection = void 0;
var utils_1 = require("../utils/utils");
var base_1 = require("./base");
var listener_1 = require("../utils/event-listener/listener");
var event_trigger_1 = require("../utils/event-trigger");
var element_from_string_1 = require("../utils/element-from-string");
var SingleSelection = /** @class */ (function (_super) {
    __extends(SingleSelection, _super);
    function SingleSelection(element, options) {
        return _super.call(this, element, options) || this;
    }
    SingleSelection.prototype.render = function () {
        var selection = _super.prototype.render.call(this);
        selection.classList.add('select2-selection--single');
        selection.innerHTML = '<span class="select2-selection__rendered"></span>' +
            '<span class="select2-selection__arrow" role="presentation">' +
            '<b role="presentation"></b>' +
            '</span>';
        return selection;
    };
    SingleSelection.prototype.binding = function (select, container) {
        var _this = this;
        _super.prototype.binding.call(this, select, container);
        var id = select.id + '-container';
        var rendered = this.selection.querySelector('.select2-selection__rendered');
        rendered.setAttribute('id', id);
        rendered.setAttribute('role', 'textbox');
        rendered.setAttribute('aria-readonly', 'true');
        this.selection.setAttribute('aria-labelledby', id);
        listener_1.createListener({
            elements: this.selection,
            events: 'mousedown',
            listeners: this.core.listeners,
            callback: function (evt) {
                // Only respond to left clicks
                if (evt.which !== 1) {
                    return;
                }
                _this.trigger('toggle', {
                    originalEvent: evt
                });
            }
        });
        select.on('focus', function () {
            if (!select.isOpen()) {
                event_trigger_1.eventTrigger(_this.selection, 'focus');
            }
        });
    };
    SingleSelection.prototype.clear = function () {
        var rendered = this.selection.querySelector('.select2-selection__rendered');
        utils_1.Utils.elementEmpty(rendered);
        rendered.removeAttribute('title'); // clear tooltip on empty
    };
    SingleSelection.prototype.display = function (data, container) {
        var template = this.options.get('templateSelection');
        var escapeMarkup = this.options.get('escapeMarkup');
        return escapeMarkup(template(data, container));
    };
    SingleSelection.prototype.selectionContainer = function () {
        return element_from_string_1.elementFromString('<span></span>');
    };
    SingleSelection.prototype.update = function (data) {
        if (data.length === 0) {
            this.clear();
            return;
        }
        var selection = data[0];
        var rendered = this.selection.querySelector('.select2-selection__rendered');
        var formatted = this.display(selection, rendered);
        utils_1.Utils.elementEmpty(rendered).append(formatted);
        var title = selection.title || selection.text;
        if (title) {
            rendered.setAttribute('title', title);
        }
        else {
            rendered.removeAttribute('title');
        }
    };
    return SingleSelection;
}(base_1.BaseSelection));
exports.SingleSelection = SingleSelection;
//# sourceMappingURL=single.js.map